import { FIELDS } from 'store/insuranceCalculation/constants';

export const NAME = FIELDS.SELECTED_BANK;
